import { Radio } from '@mui/material';

const getProcessColumns = ({ stateRef, setSelectedRow }) => [
	{
		field: 'invitee_email',
		headerName: 'Team Member Email',
		description: 'Team Member Email',
		renderCell: (cellValues) => {
			const userRole = cellValues.row?.user_role;
			const teamInvitationId = cellValues.row?.team_invitation_id;
			const invitee_email = cellValues.formattedValue;

			return (
				<>
					<Radio
						disabled={userRole === 'Application Owner'}
						checked={stateRef?.current === teamInvitationId}
						value={teamInvitationId}
						onChange={() => {
							stateRef.current = teamInvitationId;
							setSelectedRow(cellValues.row);
						}}
					/>
					{invitee_email}
				</>
			);
		},
		flex: 1,
		sortable: false,
		disableColumnMenu: true
	},
	{
		field: 'user_role',
		headerName: 'Role',
		description: 'Role',
		renderCell: (cellValues) => {
			const userRole = cellValues.row?.user_role;
			return userRole;
		},
		flex: 1,
		minWidth: 150,
		maxWidth: 150,
		sortable: false,
		disableColumnMenu: true
	}
];

export default getProcessColumns;
